<article class="page-container flex flex-column">
  <section class="pb-2">
    <p-button icon="fas fa-arrow-left" type="button" styleClass="p-button-secondary p-button-outlined"
      [label]="screen.actions.goBack" [routerLink]="[ '/admin/general/atc' ]"></p-button>

    <p-button icon="fas fa-plus" type="button" styleClass="p-button-info p-button-outlined ml-2"
      [pTooltip]="screen.actions.add" (click)="showModal()">
    </p-button>
  </section>

  <section>
    <p-table #dt [value]="medicines" [paginator]="true" [rows]="pageSize" [totalRecords]="medicines.length"
      [loading]="loading" dataKey="id" class="col-12 p-0">

      <ng-template pTemplate="colgroup" let-columns>
        <colgroup class="hide-on-small">
          <col data-id="name" [style.width.%]="20">
          <col data-id="quantity" [style.width.%]="20">
          <col data-id="instructions" [style.width.%]="60">
        </colgroup>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th scope="name">{{screen.labels.medicine}}</th>
          <th scope="quantity">{{screen.labels.quantity}}</th>
          <th scope="instructions">{{screen.labels.instructions}}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-medicine>
        <tr>
          <td>{{medicine.name}}</td>
          <td>{{medicine.quantity}}</td>
          <td>{{medicine.instructions}}</td>
        </tr>
      </ng-template>
    </p-table>
  </section>
</article>

<p-dialog header="{{screen.labels.medicineAdd}}" [(visible)]="showAddNew" [modal]="true" [blockScroll]="true"
  [draggable]="false" [closable]="!saving" [closeOnEscape]="!saving" [style]="{width: '35%', maxHeight: '50%'}">
  <form class="flex flex-column" (validate)="addNew()" novalidate>
    <div class="inline-flex align-items-center">
      <label class="col-3 pt-0 pl-0" for="medicine">{{screen.labels.medicine}}</label>
      <span class="col-9 pt-0 pr-0 form__field">
        <input pInputText validation [required]="true" name="medicine" [(ngModel)]="medicine.name" autocomplete="off" />
      </span>
    </div>

    <div class="inline-flex align-items-center">
      <label class="col-3 pt-0 pl-0" for="quantity">{{screen.labels.quantity}}</label>
      <span class="col-9 pt-0 pr-0 form__field">
        <input pInputText validation [required]="true" name="quantity" [(ngModel)]="medicine.quantity"
          autocomplete="off" />
      </span>
    </div>

    <div class="inline-flex align-items-center">
      <label class="col-3 pt-0 pl-0" for="instructions">{{screen.labels.instructions}}</label>
      <span class="col-9 pt-0 pr-0 form__field">
        <input pInputText validation [required]="true" name="instructions" [(ngModel)]="medicine.instructions"
          autocomplete="off" />
      </span>
    </div>

    <div class="align-self-end">
      <p-button [label]="screen.actions.save" class="p-button-success p-button-outlined" type="submit"
        [loading]="saving" [loadingIcon]="loadingIcon"></p-button>
    </div>
  </form>
</p-dialog>